import { Actions, ActionTypes } from './actions';
import { adapter, initialState, TopServiceState } from './state';

export function reducer(state = initialState, action: Actions): TopServiceState {
  switch (action.type) {
    case ActionTypes.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case ActionTypes.GET_ALL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.GET_ALL_SUCCESS:
      return adapter.setAll(action.entities, {
        ...state,
        isLoading: false,
        error: null,
      });

    case ActionTypes.UP_PRIORITY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.DOWN_PRIORITY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.SAVE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.SAVE_SUCCESS:
      return adapter.upsertOne(action.entity, {
        ...state,
        isLoading: false,
        error: null,
      });

    case ActionTypes.DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.DELETE_SUCCESS:
      return adapter.removeOne(action.entity.id, {
        ...state,
        isLoading: false,
        error: null,
      });

    case ActionTypes.SYNC_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    default:
      return state;
  }
}
